import React, { Component } from 'react';
import { __ } from '../Translator';
import Store from '../flux/Store';
import Navigation from '../Navigation';
import ProductPriceDetailed from "../components/ProductPriceDetailed";
import LoadingScreenOverlay from "../components/LoadingScreenOverlay";

import ScreenContainer from '../ScreenContainer';

import '../App.css';
import AppActions from "../flux/AppActions";
import AppStore from "../flux/AppStore";
import ViewerStore from '../flux/ViewerStore';
import Constants from '../flux/Constants';
import MobileOverlaySuggestingDesktop from '../components/MobileOverlaySuggestingDesktop';
import LanguageSelect from '../components/LanguageSelect';
import dispatchDataLayerEvent, { eventTypes } from '../utils/dispatchDataLayerEvent';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentScreen: { name: 'homepage' },

      products: null,
      productCategory: null,
      customProduct:  AppStore.getCustomProduct(),

      viewer: ViewerStore.getState(),
    };

    this.subscriptions = [];

    this.navigation = new Navigation(this, this.state.currentScreen.name);

    this.onProductLoadByHash = this.onProductLoadByHash.bind(this);
    this.onProductListChange = this.onProductListChange.bind(this);
    this.onProductSpecificationChange = this.onProductSpecificationChange.bind(this);
    this.onCustomProductCreated = this.onCustomProductCreated.bind(this);

    this.onCustomProductChange = this.onCustomProductChange.bind(this);
    this.onProductCategorySet = this.onProductCategorySet.bind(this);
    this.onViewerStateChange = this.onViewerStateChange.bind(this);
  }

  componentDidMount() {
    Store.events.getProductByHash.addListener(this.onProductLoadByHash);
    Store.events.getProducts.addListener(this.onProductListChange);
    Store.events.getProduct.addListener(this.onProductSpecificationChange);
    Store.events.setProduct.addListener(this.onProductSpecificationChange);
    Store.events.createCustomProduct.addListener(this.onCustomProductCreated);

    AppStore.events.initCustomProduct.addListener(this.onCustomProductChange);
    AppStore.events.updateCustomProduct.addListener(this.onCustomProductChange);
    AppStore.events.setProductCategory.addListener(this.onProductCategorySet);

    this.subscriptions.push(ViewerStore.addListener(this.onViewerStateChange));

    // @todo 2018-08-28
    // Move this forceUpdate into a component that wraps all the Screen

    dispatchDataLayerEvent({
      event: eventTypes.PAGE_VIEW,
      user_type: window.USER_TYPE,
      label: 'homepage',
    });
  }

  componentWillUnmount() {
    Store.events.getProductByHash.removeListener(this.onProductLoadByHash);
    Store.events.getProducts.removeListener(this.onProductListChange);
    Store.events.getProduct.removeListener(this.onProductSpecificationChange);
    Store.events.setProduct.removeListener(this.onProductSpecificationChange);
    Store.events.createCustomProduct.removeListener(this.onCustomProductCreated);

    AppStore.events.initCustomProduct.removeListener(this.onCustomProductChange);
    AppStore.events.updateCustomProduct.removeListener(this.onCustomProductChange);
    AppStore.events.setProductCategory.removeListener(this.onProductCategorySet);

    this.subscriptions.forEach(subscription => subscription.remove());
  }

  onCustomProductChange() {
    this.setState({ customProduct: AppStore.getCustomProduct() });
  }

  onProductCategorySet(category) {
    this.setState({ productCategory: category });
  }

  onProductLoadByHash(productCode, productPresetName, customProductHash, error) {
    if (error) {
      return;
    }

    const product = Store.getProduct(productCode);

    AppActions.setProductCategory(product.category);
    AppActions.initCustomProduct(product, Store.getCustomProduct(customProductHash));
  }

  onProductListChange(category) {
    this.setState({ products: Store.getProducts() });
  }

  onProductSpecificationChange(productCode) {
    let productSpecification = Store.getProduct(productCode);

    if (AppStore.getCustomProduct()) {
      AppActions.updateCustomProduct({ product: productSpecification });
    } else {
      AppActions.initCustomProduct(productSpecification);
    }
  }

  onCustomProductCreated(customProductHash) {
    if(customProductHash !== null){
      const customProduct = Store.getCustomProduct(customProductHash);

      // @todo 2017-10-06 Can we do this following Flux guidelines? Lunch an Action inside a Store event?
      AppActions.updateCustomProduct({
        hash: customProduct.hash,
        screenshots: customProduct.screenshots,
        simpleSpecification: customProduct.specification,
        files: customProduct.files,
        texts: customProduct.texts,
      });
    }
  }

  onViewerStateChange() {
    this.setState({ viewer: ViewerStore.getState() });
  }

  render() {
    return (
      <div className={`container-fluid app app--${this.state.currentScreen.name} ${window.USER_TYPE}`}>
        {window.USER_TYPE === 'dealer' && (
          <div className="dealer-pre-header">Dealer</div>
        )}
        <MobileOverlaySuggestingDesktop />

        <LoadingScreenOverlay />
        <LanguageSelect isStartPage={this.state.currentScreen.name === 'homepage'}  />

        <div className={`emersya-viewer ${this.state.currentScreen.name !== "configurator" ? 'not-display' : ''}`}>
          <iframe
            ref={mRef => {
              if (mRef && this.state.viewer.reference !== mRef) {
                setTimeout(() => AppActions.setViewerReference(mRef), 0);
              }
            }}
            src={this.state.viewer.code ? `//emersya.com/${Constants.ENV === 'production' ? 'showcase' : 'showcaseDev'}/${this.state.viewer.code}` : null}
            id="emersyaIframe"
            title="stutter"
            width="100%"
            height="100%">
          </iframe>
          <div className="threed-disclaimer">{__('The 3D model shown is intended for illustration purpose only.')}<br/>
              {__('Actual product may vary from the graphical representation.')}</div>
        </div>

        {this.screenShouldShowDetailedPrice(this.state.currentScreen.name) ? (
          <ProductPriceDetailed />
        ) : null}

        <ScreenContainer
            navigation={this.navigation}
            currentScreen={this.state.currentScreen}
            productCategory={this.state.productCategory}
            products={this.state.products} />

      </div>
    );
  }

  screenShouldShowDetailedPrice(screenName) {
    return this.state.customProduct && [
      'modelSelection',
      'modelPerforate',
      'modelColor',
      'configured',
      'modelFit',
      'bookAppointment',
      'thankYou'
    ].indexOf(screenName) !== -1;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/pages/Configuration.js